import React from 'react';
const MessagesConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/fb-catalogues-menu',
			component: React.lazy(() => import('../company-profile/customerAccountDetails/SideNavigationPages/Catalouge/Catalouges'))
		},
		{
			path: '/admin-products',
			component: React.lazy(() => import('../company-profile/customerAccountDetails/SideNavigationPages/Products/ProductsTable'))
		},
		{
			path: '/admin-orders',
			component: React.lazy(() => import('./index'))
		}
	]
};
export default MessagesConfig;
